import { ExtendedRouteConfig } from '@/router/types';
import InvalidAddresses from './components/invalid-addresses/invalid-addresses.vue';

export const addressCorrectionRoutes: ExtendedRouteConfig[] = [
  {
    name: 'address-correction/invalid-addresses',
    path: '/adressen-korrektur/:addressId?',
    component: InvalidAddresses,
    meta: {
      requiresAuth: true,
      title: 'Adressen-Korrektur',
    },
  },
];
